import React, {
	useState,
	useEffect
} from 'react';

import CircularProgress from "@material-ui/core/CircularProgress";


import { uploadImageApi } from "../../services/NexiDigitalAPI";
import axios from "axios";

import JoditEditor from "./lib/";
import carregandoItem from './lib/loading.gif';
import SemImagem from "../../assets/images/sem-imagem.jpg";

const iconNewButtomToolbar = 'data:image/png;base64,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';

const iconNewButtomToolbarFile = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFGUlEQVR4Xu2bWajXRRTHP1a00PaWLQb1YBkYPlk9pkKLWdEOlihBapuIL4JmWVSI9KCWlQb1km0QKdqCgtpLRT4WlBokZNr2khVUaMY35ifDufNb5rfc+f+6/3m53Pub5ZzPnDlz5szccYzxMm6M688QwNAC4gnMAjYAF8Y3jWpxCFgEvBvVKrJynSVwELgocpy61Y8C9wFv1+2grF0dAMfLOm35+zFgHvB6y/3+110fAEjOziyhDQB1+iiazDwL68QS6ghvBazTRx0AatM6hDrCjzYAmf8pHrFWl0MfANwFvGkgtGYJfQAgGe/sCkJfAGgFdAKhTwA6gdA3AK1D6AOAmADwWWB5TIP/GwDtDv6WWcpiEAE0PWxF6RRV2eHsOhBqetyO0imq8igBKDVbU6HRhAwBxOIGGhGvMV5Zk0byDC2gDG/geyPiNcYra9JInqEFlOEdWsBIAo1MrgbwsiaN5BnkJXAaMA24GZgMjAcmOBrfAT8CXwIPG0JROkVVHqVA6ALgcWA2cE7Z9Ae+R+kUVbljAKcDjwGLgTNrKK4mWg5PAzoV/lmlj0EBoFl/D7i6itAV6nwG3Ab8UFZ3EABMAd7PuW7TWt/svh8AdFJUkS+4BNDB6Vbg4oCiqjsT+KIIQmoA5wN7POeWyfo98BTwqrsVKtLhJOAOYLWD4tfVBetVgPoLlpQAzgB2OwF94TTjc4Dfy8zXfD/b3R/eYv6u5aDdJOgTUgKQs7Lpq7XAEuCfSOWz6rKGNcCjpr2s6YlQn6kAyOntN95+C3B7gfLPAEudEjL3ZTmQBEEO1beEP4CJwGHbJhWAl4CFnjByWFcUmL1uh94xwmuZ5F2Zazl8bR5xvBgImlq5Ho+FqAjvJxPk3A+8ljOjUv6NQLKz7HrsAWCj1+evwHnA3/44scKrbaPYG7gB+NATQlvdpe7m1zK4x81yXqa36KJUbb41O8z1wPbUAGSKD3pCPO/eAsUqn9UvgrAeeMjrWL8/khrALuBaT4gbgY+M9nlmn7c55C0HBUIKsrKisaenBrDPeeRMDnnnbzyhQspLwZON9vbdQAjC5c4ZZk33ApNSA/gNOMsTQh47C3rylJ8b8PhV3g1oHI2XFY2j8U6UFE7wiBFCR14JqXD2rYLXICHnG3KSsoy7XSygvuX9s6Kxz00NQGZ4mSeEzFTLwl6JWeeWt/uEICj214FJ5v6VN5ZiA8UbSS3AOkE5Km2LPoCQZy/afi2EDIB1gjuBGakB2K3pBRe7Z3eCki/0RLYs/tD5X32pLAC2AXljJbUAGwhp5hUIadaLShkA21aBkHII/rPe64AdqS3gVOBnEwrPB15pGYCs4GWvz4EJhSWTPQwpcSGH5W9ZlkeMBcj7y+Hp1JmVEVGgPqTYBjWuDiUKfvw9WdGg/IACmlCpCkDHYSVVlE7PivZ/BVwjcoSpAEgwJSlWGE11LlBWOJQQqQJAyq8LHHtXAk+GqKYEoDS4tsRrjGBbgXsDy6EMgMxex+abTH+fuPj/r0EDIHmUFP08kNWVk1QGSOs22x3yAGjW9U8Vq8yaV//yLVPdz+C6SmkBmUBXAh8EMsP6roBGqTLt6arjF820fIZSX6H/YFGeQYGQrs9ySxsAivpP9e1Tl18clYuRVEqGxpW3f84th+Cat43qWEDTd3xdAFOQs8ntLLo1rlzqAGj6jq+ycAUVf3FXXlrf2jU+tsnOqoPUAVC1717UGwLoxTR1KOSYt4B/ATdzPFDPAl8TAAAAAElFTkSuQmCC';

const JoditEditorContent = (props) => {
	const [config, setConfig] = useState({
		readonly: false,
		toolbar: true,
		buttons: [
			{
				group: 'source',
				buttons: []
			},
			{
				group: 'font-style',
				buttons: []
			},
			{
				group: 'script',
				buttons: []
			},
			{
				group: 'list',
				buttons: ['ul', 'ol']
			},
			{
				group: 'indent',
				buttons: []
			},
			{
				group: 'font',
				buttons: []
			},
			{
				group: 'color',
				buttons: []
			},
			/*{
				group: 'media',
				buttons: []
			},*/
			'\n',
			{
				group: 'state',
				buttons: []
			},
			{
				group: 'clipboard',
				buttons: []
			},
			{
				group: 'insert',
				buttons: []
			},
			{
				group: 'form',
				buttons: []
			},
			{
				group: 'history',
				buttons: []
			},
			{
				group: 'search',
				buttons: []
			},
			{
				group: 'other',
				buttons: []
			},
			{
				group: 'info',
				buttons: []
			},
			{
				group: 'file-bowser',
				buttons: []
			},
			{
				iconURL: iconNewButtomToolbar,
				name: 'insertMidia',
				tooltip: 'Inserir Mídias',

				popup: (editor, current, self, close) => {
					const form = editor.create.fromHTML(
						`
						<form style="padding: 10px;max-width: 500px;">
							<p>Escolha uma opção para inserir mídia</p>
							<input name="urlInsertIgmEditor" type="text" style="width: 100%;border: solid 1px #ccc; margin-bottom: 10px; padding: 5px;" placeholder="Insira a url da imagem" value=""/>
							<input name="urlInsertVideoEditor" type="text" style="width: 100%;border: solid 1px #ccc; margin-bottom: 10px; padding: 5px;" placeholder="Insira a url do vídeo mp4" value=""/>
							<textarea name="urlInsertEmbedtEditor" style="width: 100%;border: solid 1px #ccc; margin-bottom: 5px; padding: 5px;" placeholder="Insira o código embed" ></textarea>
							<input name="uploadInsertEditor" type="file" style="width: 100%;border: solid 1px #ccc; margin-bottom: 5px; padding: 10px;" value=""/>
							<button type="submit" style="background: #61467b;color: #fff; padding: 5px 10px; border: none;">Inserir</button>
						</form>
						`
					);
			
					editor.e.on(form, 'submit', (e) => {
						e.preventDefault();
						if( form.querySelector('input[name=urlInsertIgmEditor]').value ){
							editor.s.insertHTML('<img src="'+form.querySelector('input[name=urlInsertIgmEditor]').value+'">');

						}else if( form.querySelector('input[name=urlInsertVideoEditor]').value ){
							editor.s.insertHTML(`<video controls="" poster="" width="100%">&nbsp;
								<source src="`+form.querySelector('input[name=urlInsertVideoEditor]').value+`" type="video/mp4">&nbsp; &nbsp;Your browser does not support the video tag.
							</video>">`);

						}else if( form.querySelector('textarea[name=urlInsertEmbedtEditor]').value ){
							editor.s.insertHTML(form.querySelector('textarea[name=urlInsertEmbedtEditor]').value);

						}else if( form.querySelector('input[name=uploadInsertEditor]').value ){
							uploadMedia(form.querySelector('input[name=uploadInsertEditor]').files[0],editor);
						}
						close();
					});
			
					return form;
				}
			},
			{
				iconURL: iconNewButtomToolbarFile,
				name: 'insertFiles',
				tooltip: 'Inserir Files',
				popup: (editor, current, self, close) => {
					const form = editor.create.fromHTML(
						`
						<form style="padding: 10px;max-width: 500px;">
							<p>Carregar Arquivo</p>
							<input name="uploadInsertFileEditor" type="file" style="width: 100%;border: solid 1px #ccc; margin-bottom: 5px; padding: 10px;" value=""/>
							<button type="submit" style="background: #61467b;color: #fff; padding: 5px 10px; border: none;">Inserir</button>
						</form>
						`
					);
			
					editor.e.on(form, 'submit', (e) => {
						e.preventDefault();
						if( form.querySelector('input[name=uploadInsertFileEditor]').value ){
							uploadFile(form.querySelector('input[name=uploadInsertFileEditor]').files[0],editor);
						}
						close();
					});
			
					return form;
				}
			},
		],
	})

	const [textAreaValue, setTextAreaValue] = useState('')

	const [inputValue, setInputValue] = useState('')

	const [spin, setSpin] = useState(1)

	const [uploadItem, setUploadItem] = useState()
	const [listUploadItem, setListUploadItem] = useState()

	useEffect(() => {
		if( uploadItem || listUploadItem ){
			let verificaItem = false;
			var list = listUploadItem;

			if(uploadItem!=''){
				if( list ){
					list.map((item, index) => {
						if( item.fileName == uploadItem.fileName ){
							verificaItem = true;
							list[index].progress = uploadItem.progress;
						}
					})
					if( verificaItem === false ){
						list.push(uploadItem);
					}
				}else{
					list = new Array();
					list.push(uploadItem);
				}	
			}
			setListUploadItem(list);

			/*window.addEventListener('beforeunload', alertUser)
			return () => {
				window.removeEventListener('beforeunload', alertUser)
			}*/
			
		}
	}, [uploadItem,listUploadItem]);

	/*const alertUser = e => {
		e.preventDefault()
		e.returnValue = ''
	}*/

	useEffect(() => {
		setTextAreaValue(props.content);
	}, [textAreaValue]);





	const [image, setImage] = useState([]);
	let arrayImages = [];

	let menuData = JSON.parse(localStorage.getItem("menu-data"));
	let fileName = "fe_thumb" + props.idContentItem + "-" + Date.now();
	const configUpload = {
		fileUploadURL: "https://upload.bedigital.net.br/uploads/file",
		fileUploadMethod: "POST",
		fileUploadParam: "fileData",
		fileUploadParams: { token: menuData.token, fileName },
		fileMaxSize: 3 * 1024 * 1024 * 1024,
		//
		imageUploadURL: "https://upload.bedigital.net.br/uploads/file",
		imageUploadMethod: "POST",
		imageUploadParam: "fileData",
		imageUploadParams: { token: menuData.token, fileName },
		imageMaxSize: 3 * 1024 * 1024 * 1024,
		//
		videoUploadURL: "https://upload.bedigital.net.br/uploads/file",
		videoUploadMethod: "POST",
		videoUploadParam: "fileData",
		videoUploadParams: { token: menuData.token, fileName },
		videoMaxSize: 3 * 1024 * 1024 * 1024,
	};


	function previewFile(url) {
		const filename =
		  "fe_thumb-testesss-" + Date.now();
		const config = {
		  responseType: "blob",
		};
		axios.get(url, config).then((response) => {
		  let addFormat = "";
		  if (response.data.type.includes("image")) {
			addFormat = response.data.type.replace("image/", ".");
		  } else {
			addFormat = response.data.type.replace("video/", ".");
		  }
		  let file = new File([response.data], filename + addFormat);
		  let data = new FormData();
		  data.append("profileImage", file, file.name);
		  uploadImageApi(data)
			.then((response) => {
			  if (200 === response.status) {
				let fileName = response.data;
				setImage(arrayImages);
			  }
			})
			.catch((error) => {
			  console.log("error", error);
			});
		});
	  }


	  function uploadFile(uploadFileItem,editor){
		  	
		props.loading(true);

		let addFormat = "";
		let tipo = 'image';

		const filename = "fe_thumb-" + props.idContentItem + "-" + Date.now();

		let htmlLink = `
		<!-- inicio-`+uploadFileItem.name+` --><span>
			<a href="#">Carregando `+uploadFileItem.name+`...</a>
		</span><!-- final-`+uploadFileItem.name+` -->
		`;
		
		editor.s.insertHTML( htmlLink.replace(/@@item@@/g, carregandoItem) );

		let data = new FormData();
		data.append("fileData", uploadFileItem);
		data.append("fileName", filename);
		data.append("nameOriginal", uploadFileItem.name);

		uploadImageApi(data,{setUploadItem})
		  .then((response) => {
			if (200 === response.status) {
				let fileData = response.data;

				setUploadItem('');

				let htmlLinkoFinal = `
					<span>
						<a href="@@item@@" download="`+uploadFileItem.name+`">`+uploadFileItem.name+`</a>
					</span>
				`;			
				var reg = new RegExp(`(<!-- inicio-`+uploadFileItem.name+` -->)[^]*(<!-- final-`+uploadFileItem.name+` -->)`, "i");
				editor.value =  (editor.value).replace(reg, htmlLinkoFinal.replace(/@@item@@/g,fileData.image)  );
			}
		  })
		  .catch((error) => {
			console.log("error", error);
		  });

	  }


	  function uploadMedia(uploadFileItem,editor){
		  	
		props.loading(true);

		let addFormat = "";
		let tipo = 'image';
		if (uploadFileItem.type.includes("image")) {
			addFormat = uploadFileItem.type.replace("image/", ".");
		} else {
			tipo = 'video';
			addFormat = uploadFileItem.type.replace("video/", ".");
		}

		const filename = "fe_thumb-" + props.idContentItem + "-" + Date.now();

		let htmlVideo = `
		<!-- inicio-`+filename+` --><span>
			<video controls="" poster="@@item@@" width="100%">&nbsp;
				<source src="@@item@@" type="video/mp4">&nbsp; &nbsp;Your browser does not support the video tag.
			</video>
		</span><!-- final-`+filename+` -->
		`;
		let htmlImg = `
			<!-- inicio-`+filename+` -->
			<span>
				<img src="@@item@@" />
			</span>
			<!-- final-`+filename+` -->
		`;
		
		editor.s.insertHTML(( tipo == 'video' ? htmlVideo.replace(/@@item@@/g, carregandoItem) : htmlImg.replace(/@@item@@/g, carregandoItem) ));

		let data = new FormData();
		data.append("fileData", uploadFileItem);
		data.append("fileName", filename);
		data.append("nameOriginal", uploadFileItem.name);
		
		uploadImageApi(data,{setUploadItem})
		  .then((response) => {
			if (200 === response.status) {
				let fileData = response.data;

				setUploadItem('');

				let htmlVideoFinal = `
					<span>
						<video controls="" poster="@@item@@" width="100%">&nbsp;
							<source src="@@item@@" type="video/mp4">&nbsp; &nbsp;Your browser does not support the video tag.
						</video>
					</span>
				`;
				let htmlImgFinal = `
					<img src="@@item@@" />
				`;
				
				var reg = new RegExp(`(<!-- inicio-`+filename+` -->)[^]*(<!-- final-`+filename+` -->)`, "i");
				editor.value =  (editor.value).replace(reg, (tipo=='video'?htmlVideoFinal:htmlImgFinal).replace(/@@item@@/g,fileData.url)  );
			}				
		  })
		  .catch((error) => {
			console.log("error", error);
		  });

	  }


	const toggleToolbar = () => (
		setConfig(config => ({
			...config,
			toolbar: !config.toolbar,
		}))
	)

	const toggleReadOnly = () => (
		setConfig(config => ({
			...config,
			readonly: !config.readonly,
		}))
	)

	const handleBlurAreaChange = (textAreaValue, event) => {
		props.onChange(textAreaValue)
		//console.log('handleBlurAreaChange', textAreaValue, event)
	};

	const handleTextAreaChange = newTextAreaValue => {
		console.log('handleTextAreaChange', newTextAreaValue)

		return (
			setTextAreaValue(() => newTextAreaValue)
		)
	}

	const handleInputChange = e => {
		const {value} = e.target
		setInputValue(() => value)
		handleTextAreaChange(value)
	}

	const handleSpin = () => setSpin(spin => ++spin)

	return (
		<div style={{width:'100%'}}>
			<div style={{
				width: '100%',
				padding: (listUploadItem?'20px 20px 0px 20px':'20px'),
				background: '#eaeaea',
				color: '#212529',
			}}>
				{ ( listUploadItem ?
					
					listUploadItem.map((item, index) => {
						return (
							<div style={{marginRight: "20px",marginBottom: "20px",marginTop: "4px",display: 'inline-block'}} key={index}>
								<CircularProgress variant="determinate" value={item.progress} style={{
									verticalAlign: 'middle',display: 'inline-block',marginTop: "-4px", color: (item.progress == '100' ? '#4caf50' :'' )
								}} />
								<div style={{
									position: 'absolute',
									marginLeft: '4px',
									marginTop: '-29px',
									textAlign: 'center',
									width: '33px',
									fontSize: '12px',
								}}>{item.progress+'%'}</div>
								<div style={{
									marginLeft: '5px',
									display: 'inline-block',
								}}>{item.name}</div>
							</div>
						);
					})
					
					
				: 'Nenhum upload em andamento') }
			</div>
			<div style={{width:'100%',maxHeight:'600px',overflow: 'auto',}}>
				<JoditEditor
					config={config}
					onChange={handleBlurAreaChange}
					// onBlur={handleBlurAreaChange}
					value={textAreaValue}
				/>
			</div>	
		</div>	
	)
}

export default JoditEditorContent
